import Modal from './modal';
import Storage from './storage';
import Vacancies from './vacancies';
import Cookies from './cookies';

export const modal = new Modal();
export const storage = new Storage();
export const vacancies = new Vacancies();
export const cookies = new Cookies();

export { observer } from 'mobx-react-lite';
